import React from 'react'
import classNames from 'classnames'
import './CrossClientRollout.scss'
import { LinkButton } from '../../../components/Button/LinkButton'
import { CrossClientRolloutIllustration } from './CrossClientRolloutIllustration'

const BOOK_SETUP_CALL_URL = 'https://zocks.io/book-a-demo-client-queries'
const LEARN_MORE_URL = 'https://www.zocks.io/features/client-queries'

const ONBOARDING_STEPS = [
  { icon: 'bi-calendar-event', label: 'Book a call with our team' },
  { icon: 'bi-lightbulb', label: 'Walk us through your workflows' },
  { icon: 'bi-star', label: "We'll set up Client Queries for your needs" },
  { icon: 'bi-check-circle', label: "You're ready to go" },
]

export const CrossClientRollout: React.FC = () => {
  return (
    <div className='truly-full-size-content d-flex align-items-center justify-content-center cross-client-rollout-container'>
      <div className='d-flex align-items-center justify-content-center zocks-gap-2 cross-client-rollout-layout'>
        <div className='d-flex flex-column zocks-gap-2 cross-client-rollout-content'>
          <div className='d-flex flex-column zocks-gap-0.5'>
            <h2>Client Queries is rolling out</h2>
            <div className='paragraph-medium'>
              To make sure you get the best experience, we onboard every account personally. From day one, Client Queries works the way your practice does.
            </div>
          </div>
          <div className='d-flex flex-column gap-4 p-4 border zocks-border-color-gray-300 zocks-border-1.0 cross-client-rollout-card'>
            <h6>How to get started</h6>
            <div className='d-flex flex-column zocks-gap-1 cross-client-rollout-steps'>
              {ONBOARDING_STEPS.map(({ icon, label }) => (
                <div key={label} className='d-flex align-items-center zocks-gap-1'>
                  <div className='d-flex align-items-center justify-content-center border zocks-border-color-gray-200 zocks-bg-color-gray-100 zocks-border-0.5 cross-client-rollout-step-icon'>
                    <i className={classNames('bi', icon, 'fs-6 zocks-text-primary')} aria-hidden='true' />
                  </div>
                  <div className='paragraph-medium'>{label}</div>
                </div>
              ))}
            </div>
          </div>
          <div className='d-flex align-items-center zocks-gap-0.5'>
            <LinkButton
              variant='primary'
              className='button-medium zocks-px-0.75 zocks-border-0.5'
              to={BOOK_SETUP_CALL_URL}
              target='_blank'
              rel='noopener noreferrer'
            >
              Book a setup call
            </LinkButton>
            <LinkButton
              variant='header'
              className='button-medium zocks-px-0.75 zocks-border-0.5 d-flex align-items-center zocks-gap-0.5'
              to={LEARN_MORE_URL}
              target='_blank'
              rel='noopener noreferrer'
            >
              Learn more
              <i className='bi bi-box-arrow-up-right fs-6' aria-hidden='true' />
            </LinkButton>
          </div>
        </div>
        <CrossClientRolloutIllustration />
      </div>
    </div>
  )
}
